export default __webpack_public_path__ + "1e78dd3c141fa712b67d522792e71870.jpg";